import { Component, Input, OnInit } from '@angular/core';
import { JoiEvent } from 'src/app/store/events.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Asset } from 'globals/store/assets.data';
import { Dictionary } from '@ngrx/entity';
import { Program, Session, Setup } from 'globals/store/programs.data';
import { sessionMapReselector } from '../../store/reselectors/sessions.reselector';
import { OnSessionsViewComponent } from '../logistics/on-sessions-view.component';
import { IdsToTagDataPipe } from 'src/app/services/pipes/idsToTagData.pipe';
import { InformablePublicComponent } from 'src/app/components/informable/informable.public.component';
import { AssetLinkComponent } from '../assets/asset-link.component';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { JustTimeToHHMM } from 'src/app/services/pipes/justTimeToHHMM.pipe';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'view-setup-view',
    template: `

  <div class="field sm">
      <b>{{setup?.name}}</b>
  </div>

  <div class="field" *ngIf="setup?.setup">
    <div class="name">SETUP</div>
    <div class="value" [innerHTML]="helpers.strWithBreak(setup?.setup)"></div>
  </div>
  <div class="field" *ngIf="!!location">
    <div class="name">LOCATION</div>
    <div class="field sm">{{ location }}</div>
  </div>
  <div class="field" *ngIf="setup?.expected">
    <div class="name">EXPECTED NUMBERS</div>
    <div class="value" [innerHTML]="helpers.strWithBreak(setup?.expected)"></div>
  </div>
  <div class="field" *ngIf="setup?.capacity">
    <div class="name">CAPACITY</div>
    <div class="value" [innerHTML]="helpers.strWithBreak(setup?.capacity)"></div>
  </div>
  <div class="field">
    <div class="name">ACCESS</div>
    <span *ngIf="setup.access">{{ setup?.access | justTimeToHHMM:true }}, </span>
    {{ program | programDayDate:setup.accessDay + 1:true }}
  </div>
  <div class="field">
    <div class="name">CLEARED</div>
    <span *ngIf="setup.clear">{{ setup?.clear | justTimeToHHMM:true }}, </span>
    {{ program | programDayDate:setup.clearDay + 1:true }}
  </div>

  <div class="group" *ngIf="{ assets: setup?.assetIds | idsToItems:assets } as vars">
    <div class="name">ASSETS</div>
    <div class="not_found" *ngIf="!vars.assets?.length">No files</div>
    <asset-link *ngFor="let asset of vars.assets"
      (click)="$event.stopPropagation()"
      [asset]="asset"
      [onlyLink]="true"
    ></asset-link>
  </div>

<div class="group">
  <div class="name">SETUP NOTES</div>
  <public-informable
    [itemsInitClosed]="true"
    [singleSectionOnly]="true"
    [information]="[{ id: 'setupNotes', title: 'Setup notes', items: setup.notes, placeholder: 'No setup notes'}]"
  ></public-informable>
</div>
<div class="group">
  <div class="name">ASSOCIATED SESSIONS</div>
  <on-sessions-view 
    [readOnly]="true"
    [tags]="setup.sessionIds | idsToTagData:sessionMap"
  ></on-sessions-view>
</div>

`,
    styleUrls: [`onsite.page.scss`],
    standalone: true,
    imports: [OnSessionsViewComponent, IdsToTagDataPipe, InformablePublicComponent, AssetLinkComponent, ProgramDayDate, JustTimeToHHMM, CommonModule, IdsToItemsPipe],
})
export class ViewSetupViewComponent extends Wrapper<ViewSetupViewComponent> implements OnInit {

  @Input() programId: string
  @Input() setupId: string

  currentEvent: JoiEvent
  setup: Setup
  program: Program
  location = ''
  assets: Dictionary<Asset>
  sessionMap: Dictionary<Session> = {}


  ngOnInit() {
    this.selectProp(sessionMapReselector, null, 'sessionMap')
    this.subProp(this.store.select('events', 'event'), 'currentEvent')
    this.subProp(this.store.select('assets', 'entities'), 'assets')

    this.subCallback(this.store.select('programs', 'entities', this.programId), program => {
      if (!program) return
      this.program = program
      this.setup = program.setups[this.setupId]

      const { venueId, location } = program
      const venueObject = this.currentEvent.venues[venueId]
      if (!venueObject) this.location = location ? location: ''
      else {
        const { venue, address } = venueObject
        this.location = `${location ? location: ''}${location && (venue || address) ? ', ' : ''}${venue ? venue: ''}${venue && address ? ', ' : ''}${address || ''}`
      }    
    })

	}


}
